import { CardTitlePhotos } from "./cardIngestion";

export enum ListingDuration {
    Unknown = 0,
    Days_1 = 1,
    Days_3 = 2,
    Days_5 = 3,
    Days_7 = 4,
    Days_10 = 5,
    Days_14 = 6,
    Days_21 = 7,
    Days_30 = 8,
    Days_60 = 9,
    Days_90 = 10,
    Days_120 = 11
}

export const ListingDurationNames = {
    [ListingDuration.Unknown]: "Unknown",
    [ListingDuration.Days_1]: "1 Day",
    [ListingDuration.Days_3]: "3 Days",
    [ListingDuration.Days_5]: "5 Days",
    [ListingDuration.Days_7]: "7 Days",
    [ListingDuration.Days_10]: "10 Days",
    [ListingDuration.Days_14]: "14 Days",
    [ListingDuration.Days_21]: "21 Days",
    [ListingDuration.Days_30]: "30 Days",
    [ListingDuration.Days_60]: "60 Days",
    [ListingDuration.Days_90]: "90 Days",
    [ListingDuration.Days_120]: "120 Days",
} as const;

export interface ListingError {
    code: string;
    message: string;
    timestamp: string;
    retryable: boolean;
}

export interface PendingListing {
    accountId: string;
    cardId: string;
    packageId: string;
    friendlyPackageId: number;
    title: string;
    sku: string;
    photos: CardTitlePhotos[];
    uploadDate: string;
    listingErrors: ListingError[];
    duration: ListingDuration;
    locked: boolean;
    bulkExempt: boolean;
}